<app-navigation-bar class="hidden min-[1384px]:block" />
<app-navigation-bar-movil class="flex min-[1384px]:hidden" />
<div class="pt-[163px] max-[1350px]:pt-[81.3px] max-[1350px]:pb-[54px]">
  <router-outlet />
</div>
